export default {
  SET_STATUS_CLIENT(state, data) {
    state.status_client = data;
  },
  SET_CLIENTS_LIST(state, data) {
    state.clients = data;
  },
  SET_CLIENT(state, data) {
    state.client = data;
  },
  SET_CONTRACTS(state, data) {
    state.contracts = data;
  },
  SET_COMMENTS(state, data) {
    state.comments = data;
  },
  SET_USERS(state, data) {
    state.users = data;
  },
  SET_ACTIVITY_SPHERES(state, data) {
    state.sphere_of_activity = data;
  },
  SET_TARGETS(state, data) {
    state.targets = data;
  },
  SET_ATTACHMENT_FILES(state, data) {
    state.attachments = data;
  },
  SET_CLIENT_GROUPS(state, data) {
    state.client_groups = data;
  },
  SET_CLIENT_PAYMENT_TYPES(state, data) {
    state.client_payment_types = data;
  },
  SET_CLIENT_INTERESTED(state, data) {
    state.client_interested = data;
  },
  SET_CLIENT_REQUESTS(state, data) {
    state.client_requests = data;
  },
  SET_ONE_EMPLOYEE(state, data) {
    state.single_employee = data;
  },
  SET_INSTALLMENTS_CONTRACT(state, data) {
    state.payment_installments = data;
  },
  SET_EMPLOYEE(state, data) {
    state.employee = data;
  },
};
